import { z } from 'zod';

export const schemaEmail = z.object({
  email: z.string().email('Invalid email address'),
});

export const schemaAddressAll = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  phone: z.string().min(1, 'Phone number is required'),

  city: z.string().nullish(),
  cityArea: z.string().nullish(),
  companyName: z.string().nullish(),
  countryArea: z.string().nullish(),
  postalCode: z.string().nullish(),
  streetAddress1: z.string().nullish(),
  streetAddress2: z.string().nullish(),
  country: z.string().nullish(),
});